export const notificationChangeEvent = "nanovise:notifications-changed";

export function broadcastNotificationChange() {
  window.dispatchEvent(new Event(notificationChangeEvent));
}
